// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Gj9b","home_info":"Home_home_info__gTgqS","__title":"Home___title__TjK64","__titleData":"Home___titleData__2guYU"};